var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(180 58 58)",
    fill: "url(#paint0_linear_2_520)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_520)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-26.0625 28.5C-26.0625 28.7569 -25.9604 29.0033 -25.7788 29.185C-25.5971 29.3667 -25.3507 29.4688 -25.0938 29.4688L37.7552 29.4687L31.6579 35.5641C31.5678 35.6542 31.4963 35.7611 31.4476 35.8788C31.3989 35.9965 31.3738 36.1226 31.3738 36.25C31.3738 36.3774 31.3989 36.5035 31.4476 36.6212C31.4963 36.7389 31.5678 36.8458 31.6579 36.9359C31.7479 37.0259 31.8549 37.0974 31.9725 37.1461C32.0902 37.1949 32.2164 37.22 32.3437 37.22C32.4711 37.22 32.5973 37.1949 32.7149 37.1461C32.8326 37.0974 32.9395 37.0259 33.0296 36.9359L40.7796 29.1859C40.8698 29.0959 40.9414 28.989 40.9902 28.8713C41.0391 28.7536 41.0642 28.6274 41.0642 28.5C41.0642 28.3726 41.0391 28.2464 40.9902 28.1287C40.9414 28.011 40.8698 27.9041 40.7796 27.8141L33.0296 20.0641C32.9395 19.974 32.8326 19.9026 32.7149 19.8539C32.5973 19.8051 32.4711 19.78 32.3437 19.78C32.2164 19.78 32.0902 19.8051 31.9725 19.8539C31.8549 19.9026 31.7479 19.974 31.6579 20.0641C31.5678 20.1542 31.4963 20.2611 31.4476 20.3788C31.3989 20.4965 31.3738 20.6226 31.3738 20.75C31.3738 20.8774 31.3989 21.0035 31.4476 21.1212C31.4963 21.2389 31.5678 21.3458 31.6579 21.4359L37.7552 27.5312L-25.0938 27.5313C-25.3507 27.5313 -25.5971 27.6333 -25.7788 27.815C-25.9604 27.9967 -26.0625 28.2431 -26.0625 28.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_520",
    x1: -24.4797,
    y1: 89.3455,
    x2: 132.245,
    y2: 173.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF7912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193,
    stopColor: "#AD7712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1826,
    stopColor: "#A26914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#9E6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#A36C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4886,
    stopColor: "#B28126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#C9A33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#E0C44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC14D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#D8B847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#CEA83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    stopColor: "#BF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78624"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 31,
    fill: "white",
    transform: "translate(43 44) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRight);
export default __webpack_public_path__ + "static/media/ButtonRight.e759bdc1ce019a5cd8dbb02cf17ed8fb.svg";
export { ForwardRef as ReactComponent };